// N.B. Grid and CardGrid will use the same component name here, as CardGrid needs to listen to changes from Grid.
export const GRID_COMPONENT_NAME = 'grid-component';
